import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import styles from './SearchView.styles';
import { DeliveryOrderCriteria } from 'src/interfaces/api/DeliveryOrder';
import StatusSelect from './components/StatusSelect';
import { empty } from 'src/utils/ObjectUtils';
import DeliveryStatusSelect from './components/DeliveryStatusSelect';

const useStyles = createUseStyles(styles);

interface Props {
  searchCriteria: DeliveryOrderCriteria;
  onCriteriaChange: (criteria: DeliveryOrderCriteria) => void;
}

const SearchView: FC<Props> = ({ searchCriteria, onCriteriaChange }) => {
  const classes = useStyles();

  const handleChangeCriteria = (fieldName: keyof DeliveryOrderCriteria, value: any) => {
    const newValue = empty(value) ? undefined : value;
    onCriteriaChange({ ...searchCriteria, [fieldName]: newValue });
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>Filtrer les bon de livraison</div>

      <div className={classes.filterContainer}>
        <DeliveryStatusSelect
          value={searchCriteria.deliveryStatus || ''}
          onChange={(value) => handleChangeCriteria('deliveryStatus', value)}
          className='mr-3'
        />
        <StatusSelect value={searchCriteria.status || ''} onChange={(value) => handleChangeCriteria('status', value)} />
      </div>
    </div>
  );
};

export default SearchView;
